import { useEffect, useState } from "react";
import { MASTER_CV_ID } from "../../lib/cv-main-default";
import { fetchAutoApplyOverview } from "../../lib/jobs-api";

/**
 * Resolves the CV a Skill should run against when no explicit CV is open.
 * Picks the globally designated Main CV. A null saved pointer means the
 * profile-backed `master` target; it must never promote the most-recent CV.
 * Used by the Skills Hub and as the fallback for Spark "apply a skill".
 */
export function useDefaultCvId(enabled = true): {
  cvId: string | null;
  loading: boolean;
} {
  const [cvId, setCvId] = useState<string | null>(null);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    setLoading(true);
    fetchAutoApplyOverview()
      .then((overview) => {
        if (cancelled) return;
        const mainCvId =
          overview.rules.find((rule) => rule.key === "auto-apply")?.settings
            .defaultCvId ?? MASTER_CV_ID;
        setCvId(mainCvId);
      })
      .catch(() => {
        if (!cancelled) setCvId(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { cvId, loading };
}
